<template>
  <div id="roadmap-initiatives-data-container" class="lift-map-container">
    <div class="chart-header-container d-flex align-items-center title w-100 mw-100">
      <modal-link modal-id="Roadmap Initiatives" :content-list="contentList" :image-size="'large'"></modal-link>  
      <h4 class="text-primary pl-2">{{ title }}</h4>
    </div>      
    <div class="mt-2 mb-2">
      Initiatives are in order from this Lift Map. Click the Top checkbox to indicate this is a key area where you are focusing to improve this period.
    </div>
    <div class="mb-2">
      <a href="#" @click.prevent="reorderInitiatives">
        <button type="button" class="btn btn-primary">
          <span class="m-2">
            Reorder
          </span>
        </button>
      </a>
    </div>
    <div class="table-responsive">
      <table :id="table.id" :class="table.class" cellspacing="0" width="100%" style="padding-left: 0 !important;">
      </table>
    </div>
    <roadmap-initiatives-reorder-modal
      ref="reorderInitiativesModal"
      modal-name="roadmap-initiatives-reorder-modal"
      :initiatives="effortSetsWithFocus"
      @reorder="setReorderedInitiatives"
    />
  </div>
</template>

<script>
import $ from "jquery";
import ValueGroupMapService from "../../services/chart/value.group.map.service";
import TableService from "../../services/table.service";
import RoadmapInitiativesReorderModal from "../../modals/RoadmapInitiativesReorderModal.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";

export default {
  name: "RoadMapInitiatives",
  mixins: [ContentMixins],
  components: { RoadmapInitiativesReorderModal },
  props: {
    titleSuffix: {
      type: String,
      default: "",
    },
    effortSets: {
      type: Array,
      default: () => []
    },
    savedFocus: {
      type: Object,
      default: () => ({})
    },
    inputLiftMapData: {
      type: Object,
      default: () => ({})
    },
    savedInitiativeSequence: {
      type: Array,
      default: () => []
    },
    contentList: { type: Array, default: () => [] },
  },
  data() {
    return {
      dataTableReady: false,
      effortSetsWithFocus: [],
      initiativeSequenceNumbers: {},
      hasReorderedInitiatives: false,
      hasLockedInitiativeOrder: false,
      hasManualReorderedInitiatives: false,
      hasAppliedSavedInitiativeSequence: false,
      table: {
        id: "dt_roadmap_initiatives",
        class: "table display wrap row-border table-hover roadmap-initiatives-data-table lift-table",
        data: [],
        dataTable: null,
        columns: ValueGroupMapService.getRoadMapEffortSetsTableColumnData(),
        configuration: {
          dom: '<"top"ifB>rt<"bottom"><"clear">',
          searching: false,
          paging: false,
          pageLength: 25,
          select: true,
          processing: false,
          responsive: true,
          destroy: true,
          info: false,
          ordering: false,
          keys: true,
          sort: false,
          bSortable: false,
          bSort: false,
          buttons: [],
        }
      }
    };
  },
  mounted() {
    this.dataTableReady = true;
    this.loadData();
  },
  methods: {
    focusKey(effort) {
      if (!effort) return "";
      return `${String(effort.needType || "").toLowerCase()}:${effort.needNumber || effort.sequenceNumber}`;
    },
    getInitiativeSequenceNumber(effort) {
      const key = this.focusKey(effort);
      return typeof this.initiativeSequenceNumbers[key] != "undefined"
        ? this.initiativeSequenceNumbers[key]
        : effort.sequenceNumber;
    },
    applySavedInitiativeSequence() {
      if (this.hasManualReorderedInitiatives) return;
      if (!Array.isArray(this.savedInitiativeSequence) || !this.savedInitiativeSequence.length) {
        if (this.hasAppliedSavedInitiativeSequence) {
          this.initiativeSequenceNumbers = {};
          this.hasReorderedInitiatives = false;
          this.hasAppliedSavedInitiativeSequence = false;
        }
        return;
      }
      const sequenceNumbers = {};
      this.savedInitiativeSequence.forEach((initiative, index) => {
        const key = `${String(initiative.needType || "").toLowerCase()}:${initiative.needNumber}`;
        sequenceNumbers[key] = typeof initiative.sequenceNumber != "undefined" ? initiative.sequenceNumber : index;
      });
      this.initiativeSequenceNumbers = sequenceNumbers;
      this.hasReorderedInitiatives = true;
      this.hasAppliedSavedInitiativeSequence = true;
    },
    getLiftMapCategory(effort) {
      const liftRows = Array.isArray(this.inputLiftMapData.rows) ? this.inputLiftMapData.rows : [];
      const effortKey = this.focusKey(effort);
      const effortNeed = effort.name || effort.needName || "";
      const matchingLiftRow = liftRows.find(row =>
        this.focusKey(row) == effortKey ||
        (row.lift && this.focusKey(row.lift) == effortKey) ||
        row.need == effortNeed ||
        row.needName == effortNeed
      );
      return matchingLiftRow && matchingLiftRow.label ? matchingLiftRow.label : "--";
    },
    setEffortSetsWithFocus() {
      this.applySavedInitiativeSequence();
      this.effortSetsWithFocus = (this.effortSets || [])
        .filter(effort => effort && (effort.name || effort.needName))
        .map(effort => {
          return {
            ...effort,
            sequenceNumber: this.getInitiativeSequenceNumber(effort),
            savedFocus: !!this.savedFocus[this.focusKey(effort)]
          };
        })
        .sort((a, b) => {
          if (!this.hasReorderedInitiatives && !this.hasLockedInitiativeOrder && a.savedFocus != b.savedFocus) {
            return a.savedFocus ? -1 : 1;
          }
          return Number(a.sequenceNumber || 0) - Number(b.sequenceNumber || 0);
        });
        
    },
    lockCurrentInitiativeOrder() {
      const sequenceNumbers = {};
      const currentRows = this.table.dataTable ? this.table.dataTable.rows().data().toArray() : this.table.data;
      (currentRows || []).forEach((row, index) => {
        if (row && row.lift) {
          sequenceNumbers[this.focusKey(row.lift)] = index;
        }
      });
      this.initiativeSequenceNumbers = sequenceNumbers;
      this.hasLockedInitiativeOrder = true;
    },
    loadData() {
      this.setEffortSetsWithFocus();
      this.table.data = this.buildTableData();
      if ($.fn.dataTable.isDataTable("#" + this.table.id)) {
        $("#" + this.table.id).DataTable().clear().destroy();
        $("#" + this.table.id).empty();
      }
      $.extend(this.table.configuration, { columns: this.table.columns });
      $.extend(this.table.configuration, { data: this.table.data });
      $.extend(this.table.configuration, TableService.getTableButtons(this, "roadmap-initiatives-data-container", undefined, "Table - Roadmap Initiatives", false, "Roadmap Initiatives"));
      this.$nextTick(() => {
        this.table.dataTable = $("#" + this.table.id).DataTable(this.table.configuration);
        this.bindTableEvents();
      });
    },
    reorderInitiatives() {
      this.setEffortSetsWithFocus();
      this.$modal.show("roadmap-initiatives-reorder-modal");
    },
    setReorderedInitiatives(initiatives) {
      this.hasReorderedInitiatives = true;
      this.hasManualReorderedInitiatives = true;
      (initiatives || []).forEach((initiative, index) => {
        this.initiativeSequenceNumbers = {
          ...this.initiativeSequenceNumbers,
          [this.focusKey(initiative)]: typeof initiative.sequenceNumber != "undefined" ? initiative.sequenceNumber : index
        };
      });
      this.setEffortSetsWithFocus();
      this.table.data = this.buildTableData();
      if (this.table.dataTable) {
        this.table.dataTable.clear();
        this.table.dataTable.rows.add(this.table.data);
        this.table.dataTable.draw();
        this.bindTableEvents();
      }
      // reordering saving to parent
      this.$emit("reorder-initiatives", this.effortSetsWithFocus);
    },
    getRoadmapInitiativeSequenceForSave() {
      if (!this.hasReorderedInitiatives && !this.savedInitiativeSequence.length) return [];
      return (this.effortSetsWithFocus || []).map((effort, index) => ({
        needType: effort.needType,
        needNumber: effort.needNumber,
        sequenceNumber: typeof effort.sequenceNumber != "undefined" ? effort.sequenceNumber : index
      }));
    },
    bindTableEvents() {
      const tableSelector = "#" + this.table.id;
      const vm = this;
      $(tableSelector + " tbody").off("click", ".roadmap-initiative-display");
      $(tableSelector + " tbody").on("click", ".roadmap-initiative-display", function() {
        const rowData = vm.table.dataTable.row($(this).closest("tr")).data();
        if (rowData && rowData.lift) {
          vm.$emit("display-initiatives", rowData.lift);
        }
      });
      $(tableSelector + " tbody").off("change", ".roadmap-focus-checkbox");
      $(tableSelector + " tbody").on("change", ".roadmap-focus-checkbox", function() {
        const rowData = vm.table.dataTable.row($(this).closest("tr")).data();
        if (rowData && rowData.lift) {
          if (!vm.hasReorderedInitiatives && !vm.hasLockedInitiativeOrder) {
            vm.lockCurrentInitiativeOrder();
          }
          rowData.savedFocus = this.checked;
          rowData.lift.savedFocus = this.checked;
          vm.$emit("toggle-focus", rowData);
        }
      });
    },
    buildTableData() {
      return (this.effortSetsWithFocus || []).map(effort => {
        const lift = {
          ...effort,
          needName: effort.name || effort.needName || "",
          sequenceNumber: effort.needNumber || effort.sequenceNumber
        };
        return {
          savedFocus: effort.savedFocus,
          category: this.getLiftMapCategory(effort),
          need: effort.name || effort.needName || "",
          summary: effort.initiative || "--",
          action: effort.description || "--",
          lift
        };
      });
    },
  },
  watch: {
    effortSets: {
      handler() {
        this.setEffortSetsWithFocus();
        if (this.dataTableReady) {
          this.loadData();
        }
      },
      deep: true,
      immediate: true
    },
    savedFocus: {
      handler() {
        this.setEffortSetsWithFocus();
        if (this.dataTableReady) {
          this.loadData();
        }
      },
      deep: true
    },
    inputLiftMapData: {
      handler() {
        if (this.dataTableReady) {
          this.loadData();
        }
      },
      deep: true
    },
    savedInitiativeSequence: {
      handler() {
        if (this.dataTableReady) {
          this.loadData();
        }
      },
      deep: true
    }
  },
  computed: {
    title() {
      return this.titleSuffix ? 'Initiatives | ' + this.titleSuffix : 'Initiatives';
    },
  }
};
</script>

<style>
.roadmap-initiatives-data-table {
  font-family: "Franklin Gothic Demi Cond";
}
.roadmap-initiatives-data-table thead th {
  background-color: #2f5eb3;
  color: #fff;
  font-weight: normal;
  vertical-align: middle;
}
.roadmap-initiatives-data-table thead th .dt-column-title {
  font-family: "Franklin Gothic Demi Cond";
}
.roadmap-initiatives-data-table thead th .dt-column-order,
.roadmap-initiatives-data-table thead th:before,
.roadmap-initiatives-data-table thead th:after {
  display: none !important;
}
.roadmap-initiatives-data-table tbody td {
  background-color: #fff !important;
}
.roadmap-initiatives-data-table tbody tr:nth-child(even) td {
  background-color: #f2f2f2 !important;
}
.roadmap-initiative-display {
  cursor: pointer;
}
</style>
